import type { MouseEvent, ReactElement } from 'react'
import { ModalProps } from '@mui/material'
import { SideMenu } from '@dhl/page'
import { LegalLinksLegacy } from '@dhl/legal'
import { useMenuItems } from './MenuItems'

export type MenuItem = {
  key: string
  label: string
  active: boolean
  onClick: (event: MouseEvent<HTMLElement>) => void
  icon: ReactElement
  testId?: string
  disabled?: boolean
}

type Props = {
  isOpen?: boolean
  onClose?: ModalProps['onClose']
  isExpanded?: boolean
  toggleExpanded?: () => void
  drawerWidth: number
}

export const SideNavigation = ({ isExpanded = true, toggleExpanded, isOpen, onClose, drawerWidth }: Props) => {
  const menuItems = useMenuItems()

  return (
    <SideMenu
      isDrawerOpen={isOpen}
      drawerWidth={drawerWidth}
      onClose={onClose}
      menuItems={menuItems}
      EndComponent={<LegalLinksLegacy />}
      disableTab={false}
      inlineSubMenuItems
      toggleExpanded={toggleExpanded}
      isExpanded={isExpanded}
      navigationPath={window.location.pathname}
    />
  )
}
